module.exports = __webpack_public_path__ + "static/sample_car_left_rear.78ef2347.png";